import React from 'react';

const HeroSection = () => {
  return (
    <section className="bg-white pt-12 sm:pt-16 pb-8 px-3 sm:px-4 overflow-hidden">
      <div className="max-w-6xl mx-auto text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-1 sm:gap-2 bg-gray-100 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 mb-6 sm:mb-8">
          <span className="text-xs sm:text-sm text-gray-600">Trusted by 3.5K+ businesses</span>
          <span className="bg-[#25D366] text-white text-[10px] sm:text-xs px-1.5 sm:px-2 py-0.5 rounded-full">4.6/5</span>
        </div>

        {/* Hero Text */}
        <h1 className="text-2xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
          The #1 <span className="italic text-[#25D366]">AI Chatbot</span><br />
          <span className="italic text-[#25D366]">Management</span> Platform
        </h1>
        <p className="text-gray-600 text-sm sm:text-lg md:text-xl max-w-3xl mx-auto mb-8 sm:mb-10 leading-relaxed px-2">
          From the first customer touchpoint through support automation,
          waatee drives faster ROI with an easy-to-use, scalable platform for Telegram and WhatsApp.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-12 sm:mb-16 px-2">
          <a
            href="https://app.waatee.com/register"
            className="w-full sm:w-auto bg-gray-900 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-lg font-medium hover:bg-gray-800 transition-all"
          >
            Book a Demo
          </a>
          <a
            href="https://app.waatee.com/register"
            className="w-full sm:w-auto bg-[#25D366] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-lg font-medium hover:bg-[#1da851] transition-all border-2 border-[#25D366] hover:border-[#1da851]"
          >
            Try for Free
          </a>
        </div>

        {/* Dashboard Preview */}
        <div className="relative max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-[#e8fef0] to-[#e8f4fc] rounded-xl sm:rounded-2xl p-2 sm:p-4 md:p-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_waatee-replica/artifacts/c778nh0p_image.png" 
              alt="waatee Dashboard" 
              className="w-full rounded-lg sm:rounded-xl shadow-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
